import {Component, Input} from '@angular/core';
import {StepItem, StepperComponent} from '../stepper';
import {DHLTrackingStatus} from '../../Api/DcoApi/AktenEintraege/DHLTrackingStatus';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'versand-stepper',
  standalone: true,
  templateUrl: './versand-stepper.html',
  styleUrl: './versand-stepper.css',
  imports: [StepperComponent,NgbTooltip,CommonModule ]
})
export class VersandStepper {
  StatusList: StepItem[] = [
    {label: 'Vorbereitung', icon: 'fa-solid fa-truck-ramp-box'},
    {label: 'Versand', icon: 'fa-solid fa-truck-fast'},
    {label: 'In Auslieferung', icon: 'fa-solid fa-dolly'},
    {label: 'Ausgeliefert', icon: 'fa-solid fa-box-open'},
  ];
  @Input() CurrentStatus: DHLTrackingStatus = { status: 0 } as DHLTrackingStatus

  ActiveIndex = () => this.CurrentStatus ? this.CurrentStatus.status < 4 ? (this.CurrentStatus.status - 0.5) : 3 : 0

}
